import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  _getNormalInput,
  _getSelectInput,
  HealthInsuranceType,
  InsuranceTypes,
  Last30Days,
  Last7Days,
  LastMonth,
  ThisMonth,
  Today,
  Yesterday,
} from "../../../libs";
import { Button } from "reactstrap";
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import "../../../libs/styles/invoice.css";
import axios from "../../../axios";

export default function InsuranceRatioForm({
  getAverageRatio,
  onFormSubmitCallback,
  onFormCancel,
  props,
}) {
  const todayMoment = moment();
  const todayFormatted = todayMoment.format("YYYY-MM-DD HH:mm:ss"); // for form default
  const todayLabel = todayMoment.format("DD/MM/YYYY");
  const [dateRangeLabel, setDateRangeLabel] = useState(todayLabel);
  const { lang, handleAppError, setLoading, showMessage } = props;

  const [insuranceCompanies, setInsuranceCompanies] = useState([]);
  useEffect(() => {
    const fetchInsuranceCompanies = async () => {
      try {
        const response = await axios.get(
          "insurance-companies/get-for-dropdown"
        );
        if (response.data && response.status === 200) {
          const companiesOptions = response.data.data.map((company) => ({
            label: company.name,
            value: company.id,
          }));
          setInsuranceCompanies(companiesOptions);
        }
      } catch (error) {
        showMessage("Failed to load insurance companies", error);
      }
    };
    fetchInsuranceCompanies();
  }, []);

  const {
    control,
    handleSubmit,
    formState: { errors },
    setError,
    register,
    setValue,
  } = useForm({
    defaultValues: {
      insurancetype: InsuranceTypes.find(
        (type) => type.value === HealthInsuranceType
      ),
      fromdate: todayFormatted,
      todate: todayFormatted,
    },
  });

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      let selectedCompanyIds = [];
      if (values.insurancecompanies && values.insurancecompanies.length > 0) {
        selectedCompanyIds = values.insurancecompanies.map(
          (company) => company.value
        );
      } else {
        selectedCompanyIds = [0];
      }

      const res = await getAverageRatio({
        type: values.insurancetype.value,
        insurancecompanies: selectedCompanyIds,
        fromdate: values.fromdate,
        todate: values.todate,
      });

      if (res.data && res.status === 200) {
        onFormSubmitCallback(res.data);
        showMessage("Form submitted successfully", "success");
        setLoading(true);
      }
    } catch (error) {
      handleAppError(error);
      setLoading(true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} id="source-form">
      <div
        style={{ marginTop: "25px", border: "none" }}
        className="invoices-module"
      >
        <div className="d-flex flex-column">
          <p className="inter inter-bold mb-1 input-label">
            {window.sys_app_translate("Insurance Type *", lang)}
          </p>
          {_getSelectInput({
            control,
            inputName: "insurancetype",
            inputId: "insurancetype",
            lang: lang,
            required: true,
            width: "col-12",
            errors: errors,
            inputTitle: "Select Insurance Type",
            includeTitleInError: false,
            options: InsuranceTypes,
          })}
        </div>
        <div className="d-flex flex-column" style={{ marginTop: "16px" }}>
          <p className="inter inter-bold mb-1 input-label">
            {window.sys_app_translate("Insurance Companies *", lang)}
          </p>
          {_getSelectInput({
            control,
            inputName: "insurancecompanies",
            inputId: "insurancecompanies",
            lang: lang,
            required: false,
            width: "col-12",
            errors: errors,
            inputTitle: "Select Insurance Companies",
            includeTitleInError: false,
            multiple: true,
            closeMenuOnSelect: false,
            options: [{ label: "All", value: 0 }, ...insuranceCompanies],
          })}
        </div>

        <div className="d-flex flex-column" style={{ marginTop: "16px" }}>
          <p className="inter inter-bold mb-1 input-label">
            {window.sys_app_translate("From Date - To Date *", lang)}
          </p>
          <DateRangePicker
            onApply={(event, picker) => {
              const start = picker.startDate;
              const end = picker.endDate;

              setValue("fromdate", start.format("YYYY-MM-DD HH:mm:ss"));
              setValue("todate", end.format("YYYY-MM-DD HH:mm:ss"));

              setDateRangeLabel(
                `${start.format("DD/MM/YYYY")} - ${end.format("DD/MM/YYYY")}`
              );
            }}
            initialSettings={{
              alwaysShowCalendars: true,
              showDropdowns: true,
              ranges: {
                [Today]: [moment(), moment()],
                [Yesterday]: [
                  moment().subtract(1, "days"),
                  moment().subtract(1, "days"),
                ],
                [Last7Days]: [moment().subtract(6, "days"), moment()],
                [Last30Days]: [moment().subtract(29, "days"), moment()],
                [ThisMonth]: [
                  moment().startOf("month"),
                  moment().endOf("month"),
                ],
                [LastMonth]: [
                  moment().subtract(1, "month").startOf("month"),
                  moment().subtract(1, "month").endOf("month"),
                ],
              },
            }}
          >
            <input
              type="text"
              className="form-control"
              id="itqdatepicker"
              placeholder={window.sys_app_translate("Date Range", lang)}
              value={dateRangeLabel}
              readOnly
              style={{
                padding: "10px",
                borderRadius: "9px",
                background: "#f3f3f5",
              }}
            />
          </DateRangePicker>
        </div>

        <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
          <Button
            variant="contained"
            className="inter inter-bold action-btn cancel-btn"
            onClick={onFormCancel}
          >
            {window.sys_app_translate("Cancel", lang)}
          </Button>
          <Button
            variant="contained"
            className="action-btn inter-bold save-btn"
            type="submit"
          >
            {window.sys_app_translate("Submit", lang)}
          </Button>
        </div>
      </div>
    </form>
  );
}
